export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.dev) {
    return;
  }

  nuxtApp.hook('app:error', (error) => {
    console.log('[app:error]', error);
  });

  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.log('[vue:error] error:', error);
    console.log('[vue:error] info:', info);
    console.log('[vue:error] instance:', instance);
  });
});
